<div class="kengetal">
  <div class="kengetalaantal">{{ aantal }}</div>
  <div class="kengetalinfo">{{ kengetal.kengetalInfo }}</div>
</div>
